<template>
  <footer id="contact" class="site-footer">
    <div class="footer-inner">
      <p class="eyebrow">Open to interesting problems, sharp teams & good coffee.</p>
      <div class="footer-main">
        <h2>Have something<br><em>worth building?</em></h2>
        <div class="footer-links">
          <a href="https://github.com/erdemkaratash" target="_blank" rel="noopener noreferrer">GitHub <span>↗</span></a>
          <a href="https://erdemkaratas.itch.io" target="_blank" rel="noopener noreferrer">itch.io <span>↗</span></a>
          <a href="#top">Back to top <span>↑</span></a>
        </div>
      </div>
      <div class="footer-base">
        <strong>erdemkaratas.com</strong>
        <span>Designed & built with intent — {{ year }}</span>
      </div>
      <nav class="game-support-links" aria-label="Across the Line support">
        <strong>Across the Line</strong>
        <a href="/across-the-line/privacy.html">Privacy policy</a>
        <a href="/across-the-line/support.html">Game support</a>
      </nav>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  computed: { year() { return new Date().getFullYear(); } }
};
</script>

<style scoped>
.site-footer { border-top: var(--line); background: var(--blue); color: #fff; }
.footer-inner { width: var(--page); margin: 0 auto; padding: 34px 0 22px; }
.eyebrow {
  margin: 0 0 52px;
  font-family: "Courier New", monospace;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}
.footer-main {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(220px, 0.32fr);
  gap: 60px;
  align-items: end;
  padding-bottom: 70px;
}
h2 {
  margin: 0;
  font-family: Georgia, "Times New Roman", serif;
  font-size: clamp(3rem, 8.5vw, 8.3rem);
  font-weight: 400;
  letter-spacing: -0.065em;
  line-height: 0.83;
}
h2 em { font-weight: 700; }
.footer-links { display: flex; flex-direction: column; border-top: 2px solid #fff; }
.footer-links a {
  display: flex;
  justify-content: space-between;
  padding: 15px 2px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.65);
  font-family: "Courier New", monospace;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-decoration: none;
  text-transform: uppercase;
}
.footer-links a:hover span { transform: translate(3px, -3px); }
.footer-links span { transition: transform 150ms ease; }
.footer-base {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  padding-top: 18px;
  border-top: 1px solid rgba(255, 255, 255, 0.65);
  font-family: "Courier New", monospace;
  font-size: 0.7rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}
.game-support-links {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 24px;
  padding-top: 16px;
  font-family: "Courier New", monospace;
  font-size: 0.75rem;
}
.game-support-links a { padding: 8px 0; text-underline-offset: 4px; }
@media (max-width: 700px) {
  .eyebrow { margin-bottom: 34px; }
  .footer-main { grid-template-columns: 1fr; gap: 44px; padding-bottom: 48px; }
  .footer-base { flex-direction: column; }
}
</style>
